import request from '@/router/axios';
import website from "@/config/website";

export const loginByUsername = (tenantId, deptId, roleId, username, password, type, key, code, loginType) => request({
    url: '/api/sino-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId,
        'Dept-Id': (website.switchMode ? deptId : ''),
        'Role-Id': (website.switchMode ? roleId : ''),
        'Captcha-Key': key,
        'Captcha-Code': code,
    },
    params: {
        tenantId,
        username,
        password,
        grant_type: (website.captchaMode ? "captcha" : "password"),
        scope: "all",
        type,
        loginType
    }
});

export const LoginByPhone = (tenantId, deptId, roleId, phone, key, code, loginType) => request({
    url: '/api/sino-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId,
        'Dept-Id': (website.switchMode ? deptId : ''),
        'Role-Id': (website.switchMode ? roleId : ''),
        'Captcha-Key': key,
        'Captcha-Code': code,
    },
    params: {
        tenantId,
        grant_type: ("phone"),
        scope: "all",
        phone,
        loginType
    }
});

export const LoginByEmail = (tenantId, deptId, roleId, email, key, code) => request({
    url: '/api/sino-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId,
        'Dept-Id': (website.switchMode ? deptId : ''),
        'Role-Id': (website.switchMode ? roleId : ''),
        'Captcha-Key': key,
        'Captcha-Code': code,
    },
    params: {
        tenantId,
        grant_type: ("email"),
        scope: "all",
        email
    }
});

export const loginBySocial = (tenantId, source, code, state) => request({
    url: '/api/sino-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId
    },
    params: {
        tenantId,
        source,
        code,
        state,
        grant_type: "social",
        scope: "all",
    }
})

export const loginBySso = (state, code) => request({
    url: '/api/sino-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': state
    },
    params: {
        tenantId: state,
        code,
        grant_type: "authorization_code",
        scope: "all",
        redirect_uri: website.redirectUri,
    }
})

export const refreshToken = (refresh_token, tenantId, deptId, roleId) => request({
    url: '/api/sino-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId,
        'Dept-Id': (website.switchMode ? deptId : ''),
        'Role-Id': (website.switchMode ? roleId : '')
    },
    params: {
        tenantId,
        refresh_token,
        grant_type: "refresh_token",
        scope: "all",
    }
});

export const registerGuest = (form, oauthId) => request({
    url: '/api/sino-user/register-guest',
    method: 'post',
    params: {
        tenantId: form.tenantId,
        name: form.name,
        account: form.account,
        password: form.password,
        oauthId
    }
});

export const getButtons = () => request({
    url: '/api/sino-system/menu/buttons',
    method: 'get'
});

export const getCaptcha = () => request({
    url: '/api/sino-auth/oauth/captcha',
    method: 'get',
    authorization: false
});

export const logout = () => request({
    url: '/api/sino-auth/oauth/logout',
    method: 'get',
    authorization: false
});

export const getUserInfo = () => request({
    url: '/api/sino-auth/oauth/user-info',
    method: 'get'
});

export const sendLogs = (list) => request({
    url: '/api/sino-auth/oauth/logout',
    method: 'post',
    data: list
});

export const clearCache = () => request({
    url: '/api/sino-auth/oauth/clear-cache',
    method: 'get',
    authorization: false
});

// 竞买个人账户注册验证码
export const sendRegisterBidder = (phone, type, account, code,key) => request({
    url: '/api/sino-user/send-register-bidder',
    method: 'post',
    data: {
        phone: phone,
        type: type,
        account: account,
        code: code,
        key: key
    }
});
// 非竞买个人账户注册验证码
export const sendEmailValidate = (email, type, account) => request({
    url: '/api/sino-user/send-register-notBidder',
    method: 'post',
    params: {
        email: email,
        type: type,
        account: account
    }
});

// 手机号登录验证码
export const sendPhoneLoginValidate = (phone) => request({
    url: '/api/sino-user/send-phone-login-validate',
    method: 'post',
    params: {
        phone: phone
    }
});
// 获取招标项目种类
export const findByAtiId = (data) => {
    return request({
        url: '/sino/cms/tenderBulletin/findByAtiId',
        method: 'post',
        params: data
    })
}
// 查询所有行业分类
export const listFindPurchaseIntention = (data) => {
    return request({
        url: '/sino/cms/tenderBulletin/listFindPurchaseIntention',
        method: 'post',
        params: data
    })
}
// 获取各个公告类型对应信息
export const findTenderBulletinType = () => {
    return request({
        url: '/sino/cms/tenderBulletin/findTenderBulletinType',
        method: 'post'
    })
}
// 2.查询各个公告
export const pageFindTenderBulletin = (params) => {
    return request({
        url: '/sino/cms/tenderBulletin/pageFindTenderBulletin',
        method: 'post',
        params: {
            ...params
        }
    })
}
// 获得所有地区
export const findByAzcId = (data) => {
    return request({
        url: '/sino/cms/tenderBulletin/findByAzcId?azcId=113239029805260800',
        method: 'post',
        params: data
    })
}
